module.exports = __webpack_public_path__ + "static/media/TSF_logo.cf70c3e6.png";